<template>
    <!-- 03 : 数字化课程资源 -->
    <div class="solution-edu-part-3">
        <CommonComponentsUnionTitleWithNumber :union-title="data.partsInfo" class="education-slide-in-up" />
        <div v-if="!isMobile" class="solution-edu-part-3-container education-slide-in-up">
            <CommonComponentsCardTransform
                v-for="(cardItem, index) in data.part_3_Info.slice(0, 3)"
                :key="index"
                class="solution-edu-part-3-card"
                :background-image="cardItem.bgImage"
                hide-arrow
            >
                <template #transform-card-title>
                    <div class="solution-edu-part-3-card-title" v-html="$t(cardItem.title)" />
                </template>
                <template #transform-card-follow>
                    <div class="solution-edu-part-3-card-subtitles">
                        <div
                            v-for="(cardSubtitleItem, subIndex) in cardItem.subTitle"
                            :key="subIndex"
                            class="solution-edu-part-3-card-subtitles-item"
                        >
                            <span class="solution-edu-part-3-card-subtitle-check">
                                <CommonComponentsSVGCommonCheckIcon />
                            </span>
                            <span>
                                {{ $t(cardSubtitleItem) }}
                            </span>
                        </div>
                    </div>
                </template>
            </CommonComponentsCardTransform>
        </div>
        <div v-if="isMobile" class="solution-edu-part-3-container-mobile">
            <CommonComponentsSolutionsAcademyCustomChangingCards :card-list="data.part_3_Info.slice(0, 3)" />
        </div>
        <CommonComponentsSVGCommonBlueDownArrow class="solution-arrow-down education-slide-in-down" />
        <div class="solution-edu-part-3-center-text">{{ $t('global_solutions_edu_part_3_item_centerText') }}</div>
        <div v-if="!isMobile" class="solution-edu-part-3-container education-slide-in-up">
            <CommonComponentsCardTransform
                v-for="(cardItem, index) in data.part_3_Info.slice(3)"
                :key="index"
                class="solution-edu-part-3-card"
                :background-image="cardItem.bgImage"
                hide-arrow
            >
                <template #transform-card-title>
                    <div class="solution-edu-part-3-card-title" v-html="$t(cardItem.title)" />
                </template>
                <template #transform-card-follow>
                    <div class="solution-edu-part-3-card-subtitles">
                        <div
                            v-for="(cardSubtitleItem, subIndex) in cardItem.subTitle"
                            :key="subIndex"
                            class="solution-edu-part-3-card-subtitles-item"
                        >
                            <span class="solution-edu-part-3-card-subtitle-check">
                                <CommonComponentsSVGCommonCheckIcon />
                            </span>
                            <span>
                                {{ $t(cardSubtitleItem) }}
                            </span>
                        </div>
                    </div>
                </template>
            </CommonComponentsCardTransform>
        </div>
        <div v-if="isMobile" class="solution-edu-part-3-container-mobile">
            <CommonComponentsSolutionsAcademyCustomChangingCards :card-list="data.part_3_Info.slice(3)" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import p3CardImg1 from '@assets/imgs/Solutions/Education/part3cardbg1.png';
    import p3CardImg2 from '@assets/imgs/Solutions/Education/part3cardbg2.png';
    import p3CardImg3 from '@assets/imgs/Solutions/Education/part3cardbg3.png';
    import p3CardImg4 from '@assets/imgs/Solutions/Education/part3cardbg4.png';
    import p3CardImg5 from '@assets/imgs/Solutions/Education/part3cardbg5.png';
    import p3CardImg6 from '@assets/imgs/Solutions/Education/part3cardbg6.png';
    import { getIsMobileRef } from '~~/composables/useMatchRules.ts';

    const isMobile = getIsMobileRef();

    const data = {
        partsInfo: {
            key: '03',
            title: 'global_solutions_edu_title_3',
        },
        centerText: '',
        part_3_Info: [
            {
                title: 'global_solutions_edu_part_3_item_title_1',
                subTitle: [
                    'global_solutions_edu_part_3_item_subtitle_11',
                    'global_solutions_edu_part_3_item_subtitle_12',
                    'global_solutions_edu_part_3_item_subtitle_13',
                    'global_solutions_edu_part_3_item_subtitle_14',
                ],
                bgImage: p3CardImg1,
            },
            {
                title: 'global_solutions_edu_part_3_item_title_2',
                subTitle: [
                    'global_solutions_edu_part_3_item_subtitle_21',
                    'global_solutions_edu_part_3_item_subtitle_22',
                    'global_solutions_edu_part_3_item_subtitle_23',
                ],
                bgImage: p3CardImg2,
            },
            {
                title: 'global_solutions_edu_part_3_item_title_3',
                subTitle: [
                    'global_solutions_edu_part_3_item_subtitle_31',
                    'global_solutions_edu_part_3_item_subtitle_32',
                    'global_solutions_edu_part_3_item_subtitle_33',
                ],
                bgImage: p3CardImg3,
            },
            {
                title: 'global_solutions_edu_part_3_item_title_4',
                subTitle: [
                    'global_solutions_edu_part_3_item_subtitle_41',
                    'global_solutions_edu_part_3_item_subtitle_42',
                    'global_solutions_edu_part_3_item_subtitle_43',
                    'global_solutions_edu_part_3_item_subtitle_44',
                ],
                bgImage: p3CardImg4,
            },
            {
                title: 'global_solutions_edu_part_3_item_title_5',
                subTitle: [
                    'global_solutions_edu_part_3_item_subtitle_51',
                    'global_solutions_edu_part_3_item_subtitle_52',
                    'global_solutions_edu_part_3_item_subtitle_53',
                ],
                bgImage: p3CardImg5,
            },
            {
                title: 'global_solutions_edu_part_3_item_title_6',
                subTitle: [
                    'global_solutions_edu_part_3_item_subtitle_61',
                    'global_solutions_edu_part_3_item_subtitle_62',
                    'global_solutions_edu_part_3_item_subtitle_63',
                ],
                bgImage: p3CardImg6,
            },
        ],
    };
</script>

<style lang="less" scoped>
    .solution-edu-part-3 {
        &-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: .convert(@flex-gap-xxxl) [ @vw] .convert(@flex-gap-lg) [ @vw];
            margin-top: .convert(65px) [ @vw];

            .solution-edu-part-3-card {
                width: .convert(440px) [ @vw];
                height: .convert(555px) [ @vw];
                font-family: HarmonyOS Sans SC;
                font-style: normal;
                font-weight: 400;
                line-height: normal;

                .solution-edu-part-3-card-title {
                    font-size: .convert(@font-size-title-xl) [ @vw];
                }
                .solution-edu-part-3-card-subtitles {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    margin-top: 12px;

                    font-size: .convert(20px) [ @vw];
                    line-height: .convert(38px) [ @vw];

                    &-item {
                        display: flex;
                        align-items: self-start;
                        gap: 8px;

                        .solution-edu-part-3-card-subtitle-check {
                            display: flex;
                            margin-top: .convert(9px) [ @vw];
                            :deep(.svg-check-icon) {
                                width: .convert(18px) [ @vw];
                                height: .convert(20px) [ @vw];
                            }
                        }
                    }
                }
            }
        }

        &-container-mobile {
            width: 100%;
            margin-top: 15px;
        }

        &-arrow {
            height: .convert(194px) [ @vw];
        }

        .solution-edu-part-3-center-text {
            text-align: center;
            color: #ffffff;
            font-size: .convert(@font-size-title) [ @vw];
            color: #fff;
            line-height: normal;

            @media (max-width: @screen-mobile-width) {
                font-size: 16px;
            }
        }
    }

    :lang(en) {
        .solution-edu-part-3 {
            &-container {
                .solution-edu-part-3-card {
                    .solution-edu-part-3-card-title {
                        font-size: .convert(48px) [ @vw];
                    }
                }
            }
        }
    }
</style>
